import React from 'react';
import { CheckIcon } from 'lucide-react';
import { systemChecklist, BOX_IMAGE, PURCHASE_ANCHOR } from '../data/content';
export function SystemOverview() {
  return <section className="bg-white px-4 py-5 sm:px-6" data-id="element-144" data-mp="18tg25oet4yhn">
      <div className="mx-auto max-w-2xl text-center" data-id="element-145" data-mp="1mlch0qrgtbw3">
        <h2 className="font-heading text-base font-extrabold uppercase leading-tight text-deep sm:text-2xl" data-id="element-146" data-mp="1hnknxtf33jqb">
          The Complete 6-in-1 Ophthalmology Visual System
        </h2>
        <p className="mt-1 font-heading text-xl font-extrabold uppercase text-ink sm:text-3xl" data-id="element-147" data-mp="u02wjyzqennv">
          👁️ Ophthalmology Visual Atlas™
        </p>
        <p className="mt-0.5 font-heading text-[0.72rem] font-semibold uppercase tracking-wide text-turq sm:text-sm" data-id="element-148" data-mp="13wfvbba4vrph">
          Ready-to-use visual resources for ophthalmology study
        </p>
        <p className="mt-0.5 text-[0.72rem] font-medium text-muted sm:text-sm" data-id="element-149" data-mp="2fajowgct7du0">
          OCT Patterns • Fundus &amp; Retina • Optic Nerve • Visual Fields •
          Corneal Imaging • Multimodal Integration
        </p>

        <a href={PURCHASE_ANCHOR} className="mt-2 block" data-id="element-150" data-mp="235kuxjnin01r">
          <img src={BOX_IMAGE} alt="The six modules of the OPHTHALMOLOGY VISUAL ATLAS™ system" className="mx-auto w-full max-w-[240px] sm:max-w-xs" data-id="element-151" data-mp="285785t3cggak" />
        </a>

        <ul className="mt-2 grid grid-cols-1 gap-x-4 gap-y-1 text-left sm:grid-cols-2" data-id="element-152" data-mp="2i46gtbo40bxk">
          {systemChecklist.map(item => <li key={item} className="flex items-start gap-2" data-id="element-153" data-mp="1khfvupht039a">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-turq" strokeWidth={3} aria-hidden="true" data-id="element-154" data-mp="1peg3h4uaxe2i" />
              <span className="text-[0.86rem] leading-snug text-ink sm:text-base" data-id="element-155" data-mp="1uc7s9pzngk2h">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}